export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";